import { render } from "./DeclineModal.vue?vue&type=template&id=a85f1218"
import script from "./DeclineModal.vue?vue&type=script&lang=js"
export * from "./DeclineModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__